import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_unsubscribed_numbers_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
  first_name: fromDatatype.VarcharDatatypeInterface;
  last_name: fromDatatype.VarcharDatatypeInterface;
  user_id: fromDatatype.VarcharDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_dgmkt_unsubscribed_numbers_RowClass
  implements bl_dgmkt_unsubscribed_numbers_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
  first_name: fromDatatype.VarcharDatatypeInterface;
  last_name: fromDatatype.VarcharDatatypeInterface;
  user_id: fromDatatype.VarcharDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
